import { forwardRef } from "react";
import {
  Group as ReactAriaGroup,
  type GroupProps as ReactAriaGroupProps,
} from "react-aria-components";

import { cn } from "../utils";

export interface NcGroupProps extends ReactAriaGroupProps {
  "aria-label"?: string;
  "aria-labelledby"?: string;
}

const NcGroup = forwardRef<HTMLDivElement, NcGroupProps>(
  ({ children, className, ...props }, ref) => (
    <ReactAriaGroup data-nc="NcGroup" ref={ref} className={cn("grid gap-4", className)} {...props}>
      {children}
    </ReactAriaGroup>
  )
);

export { NcGroup };
